import React from 'react';

import type { RoutedSubTab } from 'ui/shared/Tabs/types';

import RoutedTabs from 'ui/shared/Tabs/RoutedTabs';

interface Props {
  tabs: Array<RoutedSubTab>;
  isLoading: boolean;
  shouldRender?: boolean;
}

const AddressContract = ({ tabs, isLoading, shouldRender }: Props) => {
  if (!shouldRender) {
    return null;
  }

  return (
    <RoutedTabs
      tabs={ tabs }
      segmented
      size="sm"
      containerProps={{ px: 0, pt: 0, pb: 0 }}
      separatorEnabled={ false }
      isLoading={ isLoading }
    />
  );
};

export default React.memo(AddressContract);
